import React from "react";
import MastersCobro from "./MastersCobro";

const CobroMasterBiwo = (props) => <MastersCobro usuarioId={props.match.params.usuarioId} history={props.history} />;

export default CobroMasterBiwo;
